export const getImgSizesString = ({ sm, md, lg, xl, xxl }) => {
    return `${xxl !== undefined ? `(min-width: 93.75rem) ${xxl}, ` : ''}${xl !== undefined ? `(min-width: 75rem) ${xl}, ` : ''}${lg !== undefined ? `(min-width: 64rem) ${lg}, ` : ''}${md !== undefined ? `(min-width: 48rem) ${md}, ` : ''}${sm}`;
};
